import { useEffect } from 'react';
import PropTypes from 'prop-types';

import initAnalytics from 'public/assets/js/analytics';
import 'public/assets/js/analytics/utilities';
import 'public/assets/js/lib/jquery.throttle.js';

// data
import { AnalyticsBlockList } from 'src/lib/constants';

const propTypes = {
  route: PropTypes.string.isRequired,
};

const CustomerStoryTemplateScripts = ({ route }) => {
  // This is the equivalent of importing app.js
  useEffect(() => {
    // GA
    if (!AnalyticsBlockList.has(route)) {
      initAnalytics();
    }
  }, [route]);

  return null;
};

CustomerStoryTemplateScripts.propTypes = propTypes;
export default CustomerStoryTemplateScripts;
